import { useMutation, useQueryClient } from "@tanstack/react-query";
import AckJobUseCase from "../../../../UseCase/AckJobUseCase/AckJobUseCase";
import { AckJobCmd } from "../../../../UseCase/AckJobUseCase/AckJobCmd";

export default function AcknowledgeButtonViewModel() {
  const queryClient = useQueryClient();
  const { mutate, isPending, error, reset } = useMutation({
    mutationFn: (cmd: AckJobCmd) => AckJobUseCase().execute(cmd),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["jobList"] }),
  });

  const onClickOnAck = (jobId: string) => {
    mutate({ JobId: jobId, IsJob: true });
  };

  return { onClickOnAck, isPending, error, reset };
}
